import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export const verifyIdentity = {
  title: () => i18n.t(i18nKeys.bankOnboardingSplash__verifyIdentity__title),
  description: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__verifyIdentity__description),
  primaryAction: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__verifyIdentity__primaryAction),
  secondaryAction: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__verifyIdentity__secondaryAction),
}

export const governmentId = {
  title: () => i18n.t(i18nKeys.bankOnboardingSplash__governmentId__title),
  acceptableId: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__governmentId__acceptableId),
  primaryAction: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__governmentId__primaryAction),
}

export const submitPhotoId = {
  title: () => i18n.t(i18nKeys.bankOnboardingSplash__submitPhotoId__title),
  description: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__submitPhotoId__description),
  primaryAction: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__submitPhotoId__primaryAction),
  secondaryAction: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__submitPhotoId__secondaryAction),
  maybeLater: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__verifyIdentity__secondaryAction),
}

export const submitPhotoIdBack = {
  title: () => i18n.t(i18nKeys.bankOnboardingSplash__submitPhotoIdBack__title),
  description: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__submitPhotoIdBack__description),
  primaryAction_1: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__submitPhotoIdBack__primaryAction_1),
  primaryAction_2: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__submitPhotoIdBack__primaryAction_2),
  secondaryAction: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__submitPhotoIdBack__secondaryAction),
  maybeLater: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__verifyIdentity__secondaryAction),
}

export const verificationInProgress = {
  title: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__verificationInProgress__title),
  description: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__verificationInProgress__description),
  primaryAction: () =>
    i18n.t(
      i18nKeys.bankOnboardingSplash__verificationInProgress__primaryAction
    ),
}

export const verificationComplete = {
  title: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__verificationComplete__title),
  description: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__verificationComplete__description),
  primaryAction: () =>
    i18n.t(i18nKeys.bankOnboardingSplash__verificationComplete__primaryAction),
}
